import { ReactNode } from 'react';
import { Tooltip as AriaTooltip, TooltipTrigger } from 'react-aria-components';

// Note: react-aria's Tooltip must wrap a focusable trigger (Button, Link…).
export interface TooltipProps {
  content: ReactNode;
  /** Delay before showing, ms. */
  delay?: number;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children: ReactNode;
}

/**
 * Tooltip — react-aria `TooltipTrigger` + `Tooltip`, styled on the foundation
 * (dark surface chip with the elevation shadow). Wrap a focusable element:
 * `<Tooltip content="Approve"><IconButton …/></Tooltip>`.
 */
export const Tooltip = ({
  content,
  delay = 400,
  placement = 'top',
  children,
}: TooltipProps) => (
  <TooltipTrigger delay={delay}>
    {children}
    <AriaTooltip
      placement={placement}
      offset={6}
      className="max-w-xs rounded-lg border border-default bg-surface px-2.5 py-1.5 text-xs font-medium text-fg shadow-lg entering:animate-in entering:fade-in-0 entering:zoom-in-95"
    >
      {content}
    </AriaTooltip>
  </TooltipTrigger>
);
